/**
 * useBeta — la bêta fondateur est-elle en cours ?
 *
 * Une seule source pour toute l'interface. Sans elle, chaque composant
 * devrait deviner s'il a le droit de parler d'abonnement, et il suffirait
 * d'en oublier un pour proposer un paiement qui n'existe pas.
 *
 * Le serveur est la référence : `GET /api/beta/statut`. On ne se fie pas à
 * une variable de compilation, pour que basculer la bêta ne demande pas de
 * reconstruire le frontend.
 *
 * En attendant la réponse, `chargement` vaut true et `active` vaut true : le
 * défaut PRUDENT est de masquer la vente. Afficher brièvement un prix pour le
 * retirer ensuite serait pire que de ne rien montrer.
 */

import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/** Mis en cache au niveau du module : la réponse ne change pas en cours de session. */
let cache = null;

export function useBeta() {
  const [etat, setEtat] = useState(
    cache || { active: true, jours: 180, libelle: "Bêta Fondateur", chargement: true }
  );

  useEffect(() => {
    if (cache) return;
    let vivant = true;
    axios
      .get(`${API}/beta/statut`, { timeout: 8000 })
      .then((r) => {
        const v = { ...r.data, chargement: false };
        cache = v;
        if (vivant) setEtat(v);
      })
      .catch(() => {
        // Serveur muet : on reste sur le défaut prudent, bêta active, donc
        // aucune vente proposée. Le produit reste utilisable.
        const v = { active: true, jours: 180, libelle: "Bêta Fondateur", chargement: false };
        cache = v;
        if (vivant) setEtat(v);
      });
    return () => {
      vivant = false;
    };
  }, []);

  return etat;
}

/** Le libellé à afficher pour un compte qui a des droits complets. */
export function libelleStatut({ betaActive, estFondateur }) {
  if (estFondateur || betaActive) return "Bêta Fondateur";
  return "Pro";
}

export default useBeta;
